import { render, staticRenderFns } from "./station_data.vue?vue&type=template&id=03735576"
import script from "./station_data.vue?vue&type=script&lang=ts"
export * from "./station_data.vue?vue&type=script&lang=ts"
import style0 from "./station_data.vue?vue&type=style&index=0&id=03735576&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports